import { Notify } from "quasar";

export default {
   success(messageText) {
      Notify.create({
         message : messageText,
         type    : 'positive',
         position: 'top-right'
      })
   },
   error(messageText) {
      Notify.create({
         message : messageText,
         type    : 'negative',
         position: 'top-right'
      })
   },
   info(messageText) {
      Notify.create({
         message : messageText,
         type    : 'info',
         position: 'top-right',
      })
   },
   warning(messageText) {
      Notify.create({
         message : messageText,
         type    : 'warning',
         position: 'top-right'
      })
   }
}
